export const ALERT: {[key:string] : string } = {
    NO_STOCK: "No hay stock interno",
    NO_REFERENCE: "No existe en logística"
}